import React from 'react';
import { BadgeCheck, Phone } from 'lucide-react';
import { Button } from '../../Button';
import { MobileHeader } from '../MobileHeader';
import { MobileInfoRow } from '../MobileInfoRow';
import { VerifyStepper } from '../VerifyStepper';
import { PersonPhoto } from '../../common/PersonPhoto';
import { cngs } from '../../../data/cngs';
import type { MobileNav } from '../../../types/mobile';
export function OwnerScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const {
    owner,
    reg
  } = cngs[0];
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-1022" data-mp="3ot8egizba778">
      <MobileHeader title="মালিকের তথ্য" subtitle={reg} onBack={nav.back} data-id="element-1023" data-mp="3ornicoxcmg79" />
      <VerifyStepper current={1} data-id="element-1024" data-mp="3jv6s9p6l9rrj" />
      <div className="no-scrollbar flex-1 overflow-y-auto p-4" data-id="element-1025" data-mp="3jsaxuaty9l7u">
        <div className="flex flex-col items-center rounded-xl border border-border bg-white p-5 text-center" data-id="element-1026" data-mp="3ex5cbd4gm8ka">
          <PersonPhoto src={owner.photo} name={owner.name} size={92} data-id="element-1027" data-mp="3at5umr7g13pc" />
          <p className="mt-3 font-heading text-lg font-bold text-navy-900" data-id="element-1028" data-mp="35vxfz0li7hsu">{owner.name}</p>
          <p className="text-xs text-slate-500" data-id="element-1029" data-mp="33cy0niagv62i">নিবন্ধিত মালিক</p>
          <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700" data-id="element-1030" data-mp="384phh13tlxfg">
            <BadgeCheck className="h-4 w-4" data-id="element-1031" data-mp="2uem12qrmgxxx" /> BRTA তথ্য: ✓ যাচাইকৃত
          </span>
        </div>
        <div className="mt-3 rounded-xl border border-border bg-white px-4 py-1" data-id="element-1032" data-mp="2yfxr2xeerl6n">
          <h2 className="pt-3 text-sm font-bold text-navy-900" data-id="element-1033" data-mp="3m48o1pgzh0pn">মালিকের তথ্য</h2>
          <dl data-id="element-1034" data-mp="3r3bk4kezjwlh">
            <MobileInfoRow label="নাম" value={owner.name} data-id="element-1035" data-mp="3r3to637w3f3y" />
            <MobileInfoRow label="NID" value={owner.nidMasked} mono data-id="element-1036" data-mp="3r17hs6wqj5nb" />
            <MobileInfoRow label="মোবাইল" value={owner.mobileMasked} mono data-id="element-1037" data-mp="3d3ahp0j2oh3w" />
            <MobileInfoRow label="ঠিকানা" value="মিরপুর, ঢাকা" data-id="element-1038" data-mp="3i23usrug663j" />
            <MobileInfoRow label="মালিকানার অবস্থা" value={<span className="text-emerald-700" data-id="element-1040" data-mp="21nu9k6li4xgx">সক্রিয়</span>} data-id="element-1039" data-mp="21on8wmi4skp1" />
            <MobileInfoRow label="BRTA তথ্য" value={<span className="text-emerald-700" data-id="element-1042" data-mp="26oi0ytdn7gbo">✓ যাচাইকৃত</span>} data-id="element-1041" data-mp="26ngiw4y7ltkg" />
          </dl>
        </div>
        <button onClick={() => nav.showToast('কল সুবিধা কেবল তদারক কর্মকর্তার অনুমতিতে সক্রিয়')} className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg border border-border bg-white py-3 text-sm font-semibold text-navy-800" data-id="element-1043" data-mp="c66tt1jc2lzg">
          <Phone className="h-4 w-4" data-id="element-1044" data-mp="3ulhd9q1j7x8s" /> মালিকের সাথে যোগাযোগ
        </button>
        <p className="mt-3 text-center text-[11px] text-slate-400" data-id="element-1045" data-mp="3ul91k1h5axz6">গোপনীয়তা রক্ষায় NID ও মোবাইল নম্বর আংশিক প্রদর্শিত</p>
      </div>
      <div className="border-t border-border bg-white p-3" data-id="element-1046" data-mp="3knl4v5zzbged">
        <Button onClick={() => nav.go('drivers')} className="h-11 w-full" data-id="element-1047" data-mp="3km0aphhktzh1">অনুমোদিত চালক দেখুন (৩)</Button>
      </div>
    </div>;
}